const version     = "0.2"
const releaseDate = "May 19, 2020"

export { version, releaseDate }